import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import ConnectToShopify from './ConnectToShopify';
import { syncValidateData } from '../../../../../common/validator';
import { getShopBrandId } from '../../../../../auth/selectors';
import constructUrl from './constructUrl';
import withToggle from '../../../../../common/hoc/withToggle';
import { SHOPIFY_CONNECTION_FORM, SHOPIFY_DOMAIN } from '../../constants';

const schema = Joi.object().keys({
  shopifyUrl: Joi.string()
    .regex(/^[a-zA-Z0-9-]+\.myshopify.com/)
    .required()
    .min(2)
    .max(100)
    .label('ShopifyUrl'),
});

const validate = (model) => {
  const validationResult = syncValidateData(model, schema);
  const urlError = validationResult.shopifyUrl
    ? 'Please enter your Shopify shop URL in the format {YOUR_SHOP_NAME}.myshopify.com'
    : validationResult.shopifyUrl;

  return {
    ...validationResult,
    shopifyUrl: urlError,
  };
};

const form = reduxForm({
  form: SHOPIFY_CONNECTION_FORM,
  validate,
});

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  shopifySettings: state.shopify.shopifySettings.settings,
});

const ConnectToShopifyContainer = compose(
  connect(mapStateToProps, null),
  withToggle('opened', false),
  withHandlers({
    onSubmit: props => ({ shopifyUrl }) => {
      props.openedOn();
      const redirectUri = window.location.href;
      const { shopifySettings: { accessMode, clientId, nonce, scopes } } = props;

      const clientSecondLevelDomain = shopifyUrl
        .trim()
        .replace(/^https?:\/\//, '')
        .replaceAll('/', '')
        .replace(`.${SHOPIFY_DOMAIN}`, '');

      const urlToOpen = constructUrl(clientSecondLevelDomain, clientId, scopes, redirectUri, nonce, accessMode);

      window.location.replace(urlToOpen);
    },
  }),
  form,
)(ConnectToShopify);

export default ConnectToShopifyContainer;
